var _g, _rect, _path, _path2, _path3, _path4, _path5, _ellipse, _circle, _circle2, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 171,
    viewBox: "0 0 138 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4888_81488)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.0776,
    y: 141.666,
    width: 98.4018,
    height: 9.52275,
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.0776,
    y: 141.666,
    width: 98.4018,
    height: 9.52275,
    stroke: "#A3A3A3"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.8713,
    y: 11.5225,
    width: 98.4018,
    height: 62.6915,
    fill: "#E8E8E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8713 11.5225V106.75H5V49.1664L12.9369 36.985L20.8713 11.5225Z",
    fill: "#E0E0E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.479 11.5225V106.75H134.351V49.1664L126.414 36.985L118.479 11.5225Z",
    fill: "#E0E0E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 48.8203H134.351V156.745C134.351 158.936 132.574 160.713 130.383 160.713H8.96782C6.77645 160.713 5 158.936 5 156.745V48.8203Z",
    fill: "white",
    stroke: "#EBEBEB",
    strokeWidth: 0.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.8845 92.9003C43.8845 92.345 44.1697 91.8285 44.6631 91.5737C45.7612 91.0066 47.8591 90.085 49.898 90.085C51.936 90.085 53.9741 91.0059 55.0361 91.5731C55.5146 91.8287 55.788 92.3349 55.788 92.8774C55.788 94.1552 54.3165 94.9928 53.1142 94.56C52.1484 94.2123 51.0128 93.9307 49.868 93.9307C48.7004 93.9307 47.5329 94.2236 46.5432 94.5807C45.3432 95.0137 43.8845 94.176 43.8845 92.9003Z",
    fill: "#A3A3A3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.3562 92.9003C84.3562 92.345 84.6414 91.8285 85.1348 91.5737C86.2329 91.0066 88.3308 90.085 90.3696 90.085C92.4077 90.085 94.4458 91.0059 95.5078 91.5731C95.9863 91.8287 96.2596 92.3349 96.2596 92.8774C96.2596 94.1552 94.7881 94.9928 93.5859 94.56C92.6201 94.2123 91.4845 93.9307 90.3396 93.9307C89.1721 93.9307 88.0046 94.2236 87.0148 94.5807C85.8149 95.0137 84.3562 94.176 84.3562 92.9003Z",
    fill: "#A3A3A3"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 70.072,
    cy: 109.133,
    rx: 12.697,
    ry: 5.55734,
    fill: "#A3A3A3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.149343,
    cx: 40.7104,
    cy: 60.7243,
    r: 4.76138,
    fill: "#858585"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.149343,
    cx: 98.6403,
    cy: 60.7243,
    r: 4.76138,
    fill: "#858585"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7102 60.4797V30.965C40.7102 14.9681 53.6783 2 69.6752 2C85.6722 2 98.6403 14.9681 98.6403 30.965V60.4797",
    stroke: "#C4C4C4",
    strokeWidth: 3.96781,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4888_81488",
    x: 0.88378,
    y: 122.472,
    width: 136.79,
    height: 47.9102,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.59693,
    result: "effect1_foregroundBlur_4888_81488"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.dca8eb03eb2a9d32243f0e71485b196a.svg";
export { ForwardRef as ReactComponent };